import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import {
  TextField, InputAdornment, IconButton, FormHelperText,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Trans } from 'react-i18next';
import styles from '../../assets/jss/FormStyle';
import {
  CheckIfDateIsValid,
  CheckIfNotEmpty,
  CheckIfNumbericValid,
  CheckIfValidIp,
  CheckIfEmailIsValid,
  CheckIfPasswordIsValid,
  CheckPasswordFormat,
  CheckIfNewPasswordIsValid,
  CheckIfIterationCountIsValid,
  CheckIfphoneNumberIsValid,
} from '../../helper/StringUtils';

// eslint-disable-next-line no-unused-vars
let password;
let confirmPassword;
let newPassword;
let oldPassword;

class CInput extends Component {
  static checkType = (input) => {
    if (input === 'password' || input === 'confirmPassword' || input === 'newPassword' || input === 'oldPassword'
      || input === 'MAIL_PASS') {
      return 'password';
    } if (['startDate', 'expiryDate'].includes(input)) {
      return 'date';
    } if (input === 'licenseLimit' || input === 'subInstanceLimit') {
      return 'number';
    } if (input === 'expiryDateTime') {
      return 'datetime-local';
    }
    return 'text';
  };

  dateVal = '';

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  static handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  /*
     * Function will check
     * 1) Field are empty or not
     * 2) Email, Phone number, Iteration count are valid or not
     * 3) Password and confirmPassword are equal or not
     * 4) Date is between 31/12/9999 and 01/01/1900
     */
  validateInput = (e) => {
    const { name: tempName, checkError } = this.props;
    const { name } = this.props;

    const dom = e.target;
    if (dom.type === 'date') {
      if (CheckIfDateIsValid(dom.value)) {
        checkError(dom, false);
        this.dateVal = dom.value;
      } else {
        const year = new Date(dom.value).getFullYear();
        if (year > 9999) {
          dom.value = this.dateVal;
        } else {
          this.dateVal = dom.value;
          checkError(dom, true, 'VALIDATION.DATE_INVALID');
        }
        return false;
      }
    }

    if (
      !(
        tempName === 'password'
        || tempName === 'confirmPassword'
        || tempName === 'oldPassword'
        || tempName === 'newPassword'
        || tempName === 'phoneNumber'
        || tempName === 'iterationCount'
        || tempName === 'oldIterationCount'

      )
    ) {
      if (CheckIfNotEmpty(e.target.value)) {
        checkError(dom, false);
      } else {
        checkError(dom, true);
        return false;
      }
    }

    switch (name) {
      case 'email':
      case 'companyEmail':
        CheckIfEmailIsValid(e.target.value)
          ? checkError(dom, false)
          : checkError(dom, true, 'VALIDATION.EMAIL_NVALID');
        return false;
      case 'revbitsEmail':
        CheckIfEmailIsValid(e.target.value)
          ? checkError(dom, false)
          : checkError(dom, true, 'VALIDATION.EMAIL_NVALID');
        return false;
      case 'contactEmail':
        CheckIfEmailIsValid(e.target.value)
          ? checkError(dom, false)
          : checkError(dom, true, 'VALIDATION.EMAIL_NVALID');
        return false;
      case 'ipaddress':
        CheckIfValidIp(e.target.value)
          ? checkError(dom, false)
          : checkError(dom, true, 'VALIDATION.VALID_IP');
        return false;
      case 'versionNumber':
        CheckIfNumbericValid(e.target.value)
          ? checkError(dom, false)
          : checkError(dom, true, 'VALIDATION.NUMERIC_VERSION_NUMBER');
        return false;
      case 'phoneNumber':
        if (e.target.value) {
          CheckIfphoneNumberIsValid(e.target.value)
            ? checkError(dom, false)
            : checkError(dom, true);
        }
        return false;
      case 'password':
        password = e.target.value;
        return false;
      case 'oldPassword':
        oldPassword = e.target.value;
        if (oldPassword && oldPassword !== '') {
          CheckPasswordFormat(oldPassword)
            ? checkError(dom, false)
            : checkError(dom, true, 'VALIDATION.INVALID_PASSWORD_FORMAT');
        } else {
          checkError(dom, true, 'VALIDATION.REQ_FIELD');
        }
        return false;
      case 'newPassword':
        newPassword = e.target.value;
        if (newPassword) {
          if (CheckIfNewPasswordIsValid(oldPassword, newPassword)) {
            CheckPasswordFormat(newPassword)
              ? checkError(dom, false)
              : checkError(dom, true, 'VALIDATION.INVALID_PASSWORD_FORMAT');
          } else {
            checkError(dom, true, <Trans>VALIDATION.NEW_C_PASS</Trans>);
          }
        } else {
          checkError(dom, true, 'VALIDATION.REQ_FIELD');
        }
        return false;
      case 'confirmPassword':
        confirmPassword = e.target.value;
        if (confirmPassword) {
          if (CheckIfPasswordIsValid(newPassword, confirmPassword)) {
            CheckPasswordFormat(confirmPassword)
              ? checkError(dom, false)
              : checkError(dom, true, 'VALIDATION.INVALID_PASSWORD_FORMAT');
          } else {
            checkError(dom, true, <Trans>VALIDATION.CONFIRM_N_PASS</Trans>);
          }
        } else {
          checkError(dom, true, 'VALIDATION.REQ_FIELD');
        }
        return false;
      case 'iterationCount':
        if (e.target.value) {
          CheckIfIterationCountIsValid(e.target.value)
            ? checkError(dom, false)
            : checkError(dom, true, 'Invalid iteration count');
        } else {
          checkError(dom, true, 'VALIDATION.REQ_FIELD');
        }
        return false;
      case 'oldIterationCount':
        if (e.target.value) {
          CheckIfIterationCountIsValid(e.target.value)
            ? checkError(dom, false)
            : checkError(dom, true, 'Invalid old iteration count');
        } else {
          checkError(dom, true, 'VALIDATION.REQ_FIELD');
        }
        return false;
      case 'passCode':
        e.target.value.length === 6
          ? checkError(dom, false)
          : checkError(dom, true);
        return false;
      case 'licenseLimit':
        if (e.target.value) {
          (e.target.value < 10000 && e.target.value > 0)
            ? checkError(dom, false)
            : checkError(dom, true, <Trans>VALIDATION.LICENSE_ALLOWED_INSTANCES_FORMAT</Trans>);
        } else {
          checkError(dom, true, 'VALIDATION.REQ_LICENSE_ALLOWED_INSTANCES');
        }
        return false;
      case 'subInstanceLimit':
        if (e.target.value) {
          (e.target.value < 10000 && e.target.value > 0)
            ? checkError(dom, false)
            : checkError(dom, true, <Trans>VALIDATION.LICENSE_ALLOWED_SUB_INSTANCES_FORMAT</Trans>);
        } else {
          checkError(dom, true, 'VALIDATION.REQ_LICENSE_ALLOWED_SUB_INSTANCES');
        }
        return false;

      default:
        checkError(dom, false);
    }
  };

  isValidFunction = (e) => {
    const { validateForm } = this.props;
    if (validateForm) this.validateInput(e);
  };

  handleClickShowPassword = () => {
    const { showPassword } = this.state;
    this.setState({
      showPassword: !showPassword,
    });
  };

  render() {
    const {
      theme,
      classes,
      randomKey,
      name,
      label,
      id,
      info,
      onChange,
      readonly,
      isError,
      helperText,
      errorVal,
      refP,
    } = this.props;

    const {
      showPassword,
    } = this.state;

    return (
      <React.Fragment key={randomKey || 1}>
        <TextField
          className={`${classes.formInput} ${classes.formInp}`}
          name={name}
          type={CInput.checkType(name) === 'password' ? (showPassword ? 'text' : 'password') : CInput.checkType(name)}
          InputProps={{
            className: theme.logo ? 'darkTheme ' : 'lightTheme',
            endAdornment: CInput.checkType(name) === 'password' ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  style={{
                    marginRight: (name === 'MAIL_PASS') ? '-10px' : '15px',
                    color: theme.logo ? 'white ' : 'black',
                  }}
                  onClick={this.handleClickShowPassword}
                  onMouseDown={CInput.handleMouseDownPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ) : '',

          }}
          label={label}
          id={id}
          variant="filled"
          defaultValue={info}
          onChange={onChange || this.isValidFunction}
          // onChange={this.props.handleChange}
          disabled={readonly || false}
          error={isError}
          helperText={helperText}
          ref={refP}
          format={CInput.checkType(name) === 'date' ? 'YYYY/MM/DD' : null}
        />
        <FormHelperText className={classes.error}>
          {isError
          && <Trans>{errorVal}</Trans>}
        </FormHelperText>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(CInput);
